import baseConfig from '@config/baseConfig';

const phaserConfig = baseConfig();

export const config = {
  width: phaserConfig.width,
  height: phaserConfig.height,
  audio: {
    bgAudio: null,
  },
};

export const gameState = {
  score: 0,
  attempted: 0,
  lastButton: 0,
  lastButtonName: '',
  bulbs: 0,
  beedY: 0,
  floorNo: 0,
  gameWin: false,
  win: false,
  wrong: 0,
  hintState: false,
  hintClicked: false,
  buttonState: '',
  hintUsed: 0,
  prevHint: 0,
};
